import { render, staticRenderFns } from "./RequestsPortalTab.vue?vue&type=template&id=25933979"
import script from "./RequestsPortalTab.vue?vue&type=script&lang=js"
export * from "./RequestsPortalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports